module.exports = {"TEXT":{"limit":{"lineHeight":{"min":0.8,"max":2.5,"default":1.16}}},"PPT":{"importLimit":{"assetPerSlide":50,"slidePerProject":50}},"PROJECT_TITLE":{"maxLength":50},"SWAP_TARGETS":{"FRAME_CLIP":"frame-clip","GRID_CELL":"grid-cell","WORKSPACE":"workspace","NONE":null},"SWAP_SOURCE":{"LIBRARY":"library","WORKSPACE":"workspace","NONE":null},"FRAME":{"DROP_OPACITY":0.5},"GRID":{"DROP_OPACITY":0},"IMAGE":{"DEFAULT_FILTER":"6464646464640032"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/itemConfig.json
// module id = 201
// module chunks = 0